/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Box, Chip } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";

function ChipInput({ label, items = [], onAdd, onDelete, placeholder = "Add item..." }) {
  const [inputValue, setInputValue] = useState("");

  const handleAdd = () => {
    if (inputValue.trim()) {
      onAdd(inputValue.trim());
      setInputValue("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <ArgonBox mb={2}>
      {label && (
        <ArgonTypography variant="body2" fontWeight="medium" mb={2} display="block">
          {label}
        </ArgonTypography>
      )}

      <Box display="flex" gap={1} mb={2}>
        <ArgonInput
          fullWidth
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <ArgonButton
          color="primary"
          variant="contained"
          onClick={handleAdd}
          disabled={!inputValue.trim()}
          sx={{ minWidth: "60px" }}
        >
          Add
        </ArgonButton>
      </Box>

      {items.length > 0 && (
        <Box display="flex" flexWrap="wrap" gap={1}>
          {items.map((item, index) => (
            <Chip
              key={index}
              label={item}
              onDelete={() => onDelete(index)}
              color="primary"
              variant="outlined"
              size="small"
            />
          ))}
        </Box>
      )}
    </ArgonBox>
  );
}

export default ChipInput;
